import React, { useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../../utils/toast";
import ButtonUI from "../../../material-ui/ButtonUI";
import deleteBeneficiary from "../../../../api/deleteBeneficiary";
import { AuthContext } from "../../../../context/Auth/AuthContext";
import { DeleteActionButton } from "../../../common/ActionIconButton";
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteBeneficiaryPopup = ({ setIsBeneficiaryDeleted, data }) => {
  const { contact_id } = data;
  const [open, setOpen] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onDeleteClientFormSubmit = async () => {
    const deleteClientFormResponse = await deleteBeneficiary({
      token: token,
      id: contact_id,
    });

    if (deleteClientFormResponse?.code === 200) {
      setIsBeneficiaryDeleted((prev) => (prev === true ? false : true));
      setOpen(false);
      showSuccess("Beneficiary is deleted successfully");
    } else {
      setOpen(false);
      showError("Error while Deleting Beneficiary");
    }
  };

  return (
    <div className="dialog-modal">
      <DeleteActionButton onClick={handleClickOpen} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <DeleteIcon />
          </div>
          <div className="popup-header-title">Delete Client</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this client ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onDeleteClientFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteBeneficiaryPopup;
